import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
  UncontrolledCollapse } from 'reactstrap';

const IconFAQs = () => (
  <svg width="25px" height="25px" viewBox="0 0 25 25">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-819.000000, -257.000000)" fill="#3989E3" fillRule="nonzero">
              <g transform="translate(0.000000, 242.000000)">
                  <path d="M844,27.5 C844,34.4050907 838.403075,40 831.5,40 C824.596925,40 819,34.4050907 819,27.5 C819,20.5989415 824.596925,15 831.5,15 C838.403075,15 844,20.5989415 844,27.5 Z M831.835433,19.1330645 C829.088609,19.1330645 827.336694,20.2901714 825.960988,22.3466734 C825.782762,22.6131048 825.842389,22.9724294 826.097833,23.166129 L827.846774,24.4922379 C828.109123,24.6911794 828.482913,24.6438508 828.686744,24.3852823 C829.587147,23.243246 830.204536,22.580998 831.575,22.580998 C832.604687,22.580998 833.878327,23.2436996 833.878327,24.2421875 C833.878327,24.9970262 833.255192,25.3846774 832.238508,25.9546875 C831.052823,26.6193548 829.483871,27.446623 829.483871,29.516129 L829.483871,29.7177419 C829.483871,30.0517641 829.754688,30.3225806 830.08871,30.3225806 L832.91129,30.3225806 C833.245312,30.3225806 833.516129,30.0517641 833.516129,29.7177419 L833.516129,29.6505544 C833.516129,28.2159778 837.708972,28.15625 837.708972,24.2741935 C837.708972,21.3507056 834.676462,19.1330645 831.835433,19.1330645 L831.835433,19.1330645 Z M831.5,31.6330645 C830.221522,31.6330645 829.181452,32.6731351 829.181452,33.9516129 C829.181452,35.2300403 830.221522,36.2701613 831.5,36.2701613 C832.778478,36.2701613 833.818548,35.2300403 833.818548,33.9516129 C833.818548,32.6731351 832.778478,31.6330645 831.5,31.6330645 Z" id="Shape"></path>
              </g>
          </g>
      </g>
  </svg>
);

class FAQs extends Component {
  render() {
    return (
      <div className="tab-faqs">

        <Row className="mb-4 align-items-center">
          <Col>
            <h3 className="mb-md-0 text-center text-md-left">Frequently Asked Questions</h3>
            <p className="mb-0 text-center text-md-left">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.</p>
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12}>

            <Card className="faq-card">
              <CardHeader className="text-left"><h4 className="mb-0">Getting Started</h4></CardHeader>
              <ListGroup>
                <ListGroupItem>
                  <Link to="#" id="faq1" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq1">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq2" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet consectetur?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq2">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq3" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq3">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
              </ListGroup>
            </Card>

            <Card className="faq-card">
              <CardHeader className="text-left"><h4 className="mb-0">Lorem Ipsum Dolor Sit Amet</h4></CardHeader>
              <ListGroup>
                <ListGroupItem>
                  <Link to="#" id="faq4" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq4">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq5" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet consectetur?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq5">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq6" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq6">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq7" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet consectetur?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq7">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
              </ListGroup>
            </Card>

            <Card className="faq-card">
              <CardHeader className="text-left"><h4 className="mb-0">Lorem Ipsum Dolor Sit</h4></CardHeader>
              <ListGroup>
                <ListGroupItem>
                  <Link to="#" id="faq8" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq8">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq9" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet consectetur?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq9">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
              </ListGroup>
            </Card>

            <Card className="faq-card">
              <CardHeader className="text-left"><h4 className="mb-0">Consectetur adipiscing elit sed do</h4></CardHeader>
              <ListGroup>
                <ListGroupItem>
                  <Link to="#" id="faq10" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq10">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq11" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet consectetur?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq11">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
                <ListGroupItem>
                  <Link to="#" id="faq12" className="faq-question">
                    <IconFAQs />
                    <span className="pl-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod?</span>
                  </Link>
                  <UncontrolledCollapse toggler="#faq12">
                    <br />
                    <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt magni, voluptas debitis
                    similique porro a molestias consequuntur earum odio officiis natus, amet hic, iste sed
                    dignissimos esse fuga! Minus, alias.</p>
                  </UncontrolledCollapse>
                </ListGroupItem>
              </ListGroup>
            </Card>

          </Col>
        </Row>

      </div>
    )
  }
}

export default FAQs;
